import i18nBase, { StringMap } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  initReactI18next,
  useTranslation as useTranslationBase,
} from 'react-i18next';

import en from 'app/locales/en.json';
import lt from 'app/locales/lt.json';

export const defaultNS = 'translation';

export const resources = {
  en: {
    [defaultNS]: en,
  },
  lt: {
    [defaultNS]: lt,
  },
} as const;

i18nBase
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources,
  });

// i18n type override until i18next types are figured out
export const i18n = i18nBase as {
  t: (key: string, options?: StringMap) => string;
};

// useTranslation type override until i18next types are figured out
export const useTranslation = useTranslationBase as () => {
  t: (key: string, options?: StringMap) => string;
};
